/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.students.scheduling.teacher-fte'},
});

const TeacherFteItem = () => (
  <RouteLinkItem
    route="midas/students/scheduling/teacher-fte"
    title={messages.title}
  />
);

export default TeacherFteItem;
